import { resolveStaticPath } from '@/lib';
import { tv } from "tailwind-variants";

const style = tv({
  slots: {
    avatarContaer: "w-[36px] min-w-[36px] h-[36px] md:w-[48px] md:min-w-[48px] md:h-[48px] relative",
  },
  variants: {
    asLoading: {
      true: {
        avatarContaer: "w-[56px] min-w-[56px] h-[56px]",
      },
    },
    mini: {
      true: {
        avatarContaer: "w-[28px] min-w-[28px] h-[28px] md:w-[48px] md:min-w-[48px] md:h-[48px]",
      },
    },
  },
})();

interface PerfectCornerProps {
  src: string;
  padding?: number;
  asLoading?: boolean;
  mini?: boolean;
}

export const PerfectCorner = ({ src, padding = 0, asLoading, mini }: PerfectCornerProps) => {
  const safePadding = Math.max(0, Math.min(padding, 100));
  const imageSize = 100 - safePadding * 2;
  const offset = (40 * safePadding) / 100;

  return (
    <div className={style.avatarContaer({ asLoading, mini })}>
      <div
        data-v-06d4f61d=""
        className="absolute inset-0 m-auto size-0 bg-transparent shadow-[0_0_20px_20px_#00000020] content-['']"
      ></div>
      <svg
        data-v-06d4f61d=""
        className="absolute h-full w-full left-0 top-0"
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        viewBox="0 0 40 40"
      >
        <path
          data-v-06d4f61d=""
          d="M0 18 Q0 0 18 0 L22 0 Q40 0 40 18 L40 22 Q40 40 22 40 L18 40 Q0 40 0 22 Z"
          fill="#000000"
          strokeWidth="0"
        ></path>
        <clipPath data-v-06d4f61d="" id="RdiasxhMeDTqeYRegl5Ww">
          <path data-v-06d4f61d="" d="M0 18 Q0 0 18 0 L22 0 Q40 0 40 18 L40 22 Q40 40 22 40 L18 40 Q0 40 0 22 Z"></path>
        </clipPath>
        <image
          data-v-06d4f61d=""
          style={{ width: `${imageSize}%`, height: `${imageSize}%` }}
          x={offset}
          y={offset}
          clipPath="url(#RdiasxhMeDTqeYRegl5Ww)"
          xlinkHref={resolveStaticPath(src) || "/share/avatar_default.png"}
        ></image>
        <path
          data-v-06d4f61d=""
          className="op-0"
          d="M0 18 Q0 0 18 0 L22 0 Q40 0 40 18 L40 22 Q40 40 22 40 L18 40 Q0 40 0 22 Z"
          fill="transparent"
          stroke="#000000"
          strokeWidth="0"
        ></path>
      </svg>
    </div>
  );
};
